export default __webpack_public_path__ + "static/1158-74b08355754c370bfc8ca15ae3c74078.gif";